import { Button } from '@/components/ui/button';
import { useFormContext } from './tanstack-form.context';
import { useStore } from '@tanstack/react-form';
import { useResponsive } from '@/hooks/use-responsive';

const CMSFormSubmit = ({ text }: { text: string }) => {
  const { isMobile } = useResponsive();
  const form = useFormContext();
  const [canSubmit, isSubmitting] = useStore(form.store, (state) => [
    state.canSubmit,
    state.isSubmitting,
  ]);

  return (
    <div>
      <div className="mt-6 md:mt-10 md:max-w-[466px] md:mx-auto">
        <Button
          size={isMobile ? 'extraSmall' : 'medium'}
          className="w-full"
          disabled={!canSubmit}
          loading={isSubmitting}
        >
          {text}
        </Button>
      </div>
    </div>
  );
};

export { CMSFormSubmit };
